import initialState from './initialState';
import * as types from '../actions/actionTypes';

export default function postReducer(state = initialState.posts, action) {
    switch (action.type) {
        case (types.LOAD_POSTS_SUCCESS):
            return action.posts
        case (types.SAVE_POST_SUCCESS):
            return [action.post, ...state]
        case (types.EDIT_POST_SUCCESS):
            return state.map(post => post._id === action.post._id ? action.post : post)
        case (types.DELETE_POST_SUCCESS):
            return state.filter(post => post._id !== action.postId)
        case (types.GET_USER_POSTS_SUCCESS):
            return action.userPosts
        default:
            return state;
    }
}